/* eslint-disable max-len */
export default function AgendaItemFollowupController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  docDataService,
  editFindingCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Agenda Item Note Added';
  vm.isExpanded = false;
  vm.canEditItem = vm.canEdit;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleDeleteAgendaItemFollowup = _handleDeleteAgendaItemFollowup;
  vm.handleDiscussAgendaItemFollowup = _handleDiscussAgendaItemFollowup;
  vm.handleCompleteAgendaItemFollowup = _handleCompleteAgendaItemFollowup;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleDeleteAgendaItemFollowup($event) {
    ssDialogService.dialogs.oversight.deleteAgendaItemFollowupConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Follow up?',
        message: `Are you sure you want to delete this follow up "${vm.agendaItemFollowupDetail.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.oversight.deleteAgendaItemFollowupConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return oversightDataService.deleteAgendaItemFollowup(vm.agendaItemFollowupDetail.followupItemId)
      .then(() => {
        alerts.success('The Followup Item has been deleted successfully.');
        $rootScope.$broadcast('refreshAgendaItemEdit', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Note.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.deleteAgendaItemFollowupConfirmDialog);
  }

  function _handleDiscussAgendaItemFollowup() {
    loaderService.showViewLoader = true;
    vm.agendaItemFollowupDetail.followupItemStatusId = 2;
    return oversightDataService.discussAgendaItemFollowup(vm.agendaItemFollowupDetail.followupItemId, vm.agendaItemFollowupDetail)
      .then(() => {
        alerts.success('The Followup Item has been discussed successfully.');
        $rootScope.$broadcast('refreshAgendaItemEdit', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
      }).catch(() => {
        alerts.error('Error occurred while update the followup.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCompleteAgendaItemFollowup() {
    loaderService.showViewLoader = true;
    vm.agendaItemFollowupDetail.followupItemStatusId = 3;
    return oversightDataService.completeAgendaItemFollowup(vm.agendaItemFollowupDetail.followupItemId, vm.agendaItemFollowupDetail)
      .then(() => {
        alerts.success('The Followup Item has been completed successfully.');
        $rootScope.$broadcast('refreshAgendaItemEdit', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
      }).catch(() => {
        alerts.error('Error occurred while update the followup.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }
}

AgendaItemFollowupController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'confirmDialog',
  'docDataService',
  'editFindingCommentDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
